import axios from "axios";
import { API_URL, API_URL_PUBLIC } from "const/constants";

/**
 * PR enquiry endpoints. Staff calls ride the global Authorization header and need the
 * pr:enquiry:* permissions; the public submission is anonymous and deliberately drops it.
 */

const BASE = `${API_URL}/pr-enquiries`;

const EMPTY_PAGE = { content: [], totalItems: 0, totalPages: 0 };

/** The table's New / Converted / All toggle, as the backend's optional `converted` flag. */
const CONVERTED_PARAM = { "not-converted": false, converted: true };

const dataOf = (response) => response?.data?.data ?? null;

export const prEnquiryUrl = (id) => `${BASE}/${id}`;

export const fetchPrEnquiryPage = async ({
  page = 0,
  pageSize = 20,
  search = "",
  convertedFilter = "all",
} = {}) => {
  const converted = CONVERTED_PARAM[convertedFilter];
  const params = {
    page,
    size: pageSize,
    ...(search.trim() ? { search: search.trim() } : {}),
    ...(converted === undefined ? {} : { converted }),
  };
  const response = await axios.get(BASE, { params });
  return dataOf(response) ?? EMPTY_PAGE;
};

export const fetchPrEnquiry = async (id) => dataOf(await axios.get(prEnquiryUrl(id)));

/** Creates the client the enquiry describes, or links the existing one; safe to repeat. */
export const convertPrEnquiry = async (id) =>
  dataOf(await axios.post(`${prEnquiryUrl(id)}/convert`));

/** The organization's active public link, or null when it has none. */
export const fetchPrEnquiryShareLink = async () => dataOf(await axios.get(`${BASE}/share-link`));

/** Replaces any active link with a new one that has no expiry and no submission cap. */
export const createPrEnquiryShareLink = async () =>
  dataOf(await axios.post(`${BASE}/share-link`, {}));

export const submitPublicPrEnquiry = (slug, payload) =>
  axios.post(`${API_URL_PUBLIC}/public/pr-enquiry/${encodeURIComponent(slug)}`, payload, {
    headers: { Authorization: null },
  });
